export function extractVariables(text: string): string[] {
  // Add defensive check for null or undefined text
  if (!text) {
    console.warn('extractVariables called with null or undefined text');
    return [];
  }

  const variables: string[] = [];
  let remaining = text;

  console.log('Extracting variables from text:', text);

  while (remaining.includes('{{')) {
    const start = remaining.indexOf('{{');
    const end = remaining.indexOf('}}', start);

    if (end === -1) break;

    const fullMatch = remaining.slice(start, end + 2);
    const name = remaining.slice(start + 2, end).trim();

    console.log('Found variable match:', fullMatch, 'name:', name);
    if (name) variables.push(name);

    remaining = remaining.slice(end + 2);
  }

  console.log('Extracted variables:', variables);
  return [...new Set(variables)];
}

export function replaceVariables(
  text: string,
  variables: { name: string; value: string }[]
): string {
  // Add defensive check for null or undefined text
  if (!text) {
    console.warn('replaceVariables called with null or undefined text');
    return '';
  }

  // Add defensive check for null or undefined variables array
  if (!variables || !Array.isArray(variables)) {
    console.warn('replaceVariables called with invalid variables array:', variables);
    return text;
  }

  let result = text;

  // NOTE: do not console.log the text/variable values here — they may contain
  // sensitive prompt content.

  // Sort variables by length (longest first) to avoid partial replacements
  const sortedVars = [...variables].sort((a, b) => b.name.length - a.name.length);

  for (const { name, value } of sortedVars) {
    // Match {{name}} tolerating interior whitespace ({{ name }}), which
    // extractVariables trims off — a bare `{{${name}}}` pattern would never
    // match a spaced placeholder (#71).
    const pattern = new RegExp(`\\{\\{\\s*${escapeRegExp(name)}\\s*\\}\\}`, 'g');

    // A FUNCTION replacement inserts `value` literally: passing a string
    // replacement lets String.replace interpret `$&`, `$1`, etc. in
    // user-supplied values (#3), and a global regex replaces every occurrence
    // in a single pass so a value containing its own placeholder can't loop
    // forever (#93).
    result = result.replace(pattern, () => value);
  }

  return result;
}

/** Escape a string for safe use inside a RegExp. */
function escapeRegExp(input: string): string {
  return input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
